<template lang='pug'>
  div
    vue-progress-bar
    v-toolbar(app, dark, flat, style='background: #eee')
      v-toolbar-side-icon.tertiary--text(@click.stop='drawer = !drawer')
      v-toolbar-title.tertiary--text.font-weight-light {{ $route.name }}
      v-spacer
      div(v-if="profile === 'attendant' || profile === 'manager'")
        v-tooltip(bottom v-show= "phoneActivated")
          template(v-slot:activator="{on}")
            v-btn(v-if="loaded === true" icon v-on="on"  @click="OnPause" v-show= "phoneActivated && userData.ramalNumber !== '' && userData.ramalNumber !== undefined ")
              v-icon(:color="paused ? 'green' : 'red'" v-show= "phoneActivated") pause
          div(v-if="paused === false &&  phoneActivated === true && loaded === true ")
            span  O ramal {{ this.userData.ramalNumber }} está conectado, aperte aqui para pausar
          div(v-if="paused === true && loaded === true ")
            span  O ramal {{ this.userData.ramalNumber }} está PAUSADO, aperte aqui para ficar disponível novamente
        v-tooltip(bottom v-show= "!paused")
          template(v-slot:activator="{on}")
            v-btn(v-if="loaded === true" icon v-on="on"  @click="phoneClick" v-show= "!paused && userData.ramalNumber !== '' && userData.ramalNumber !== undefined ")
              v-icon(:color="phoneActivated ? 'green' : 'red'" v-on="on" v-show= "!paused") {{telefone}}
          div(v-if="phoneActivated === true && paused == false && loaded === true ")
            span  O ramal {{ this.userData.ramalNumber }} está conectado , clique no telefone para desconectar
          div(v-if="phoneActivated === false && loaded === true ")
            span  O ramal {{ this.userData.ramalNumber }} está desconectado, clique no telefone para conectar
      v-menu(offset-y)
        template(v-slot:activator='{ on }')
         div(v-if="profile === 'supervisor' || profile === 'manager'")
          v-btn(icon v-on='on')
            v-icon(color="black") notifications
        v-list
          v-subheader Data de atualização das bases
          v-list-tile(
              v-for='(item, index) in covenantUpdatedDate',
              :key='index'
            )
            v-list-tile-content
              v-list-tile-title {{ item.name }} : {{ item.date | date }}
      v-snackbar(v-if="profile === 'supervisor' || profile === 'manager'" v-model='snackbar' :timeout='timeout' :hidden="snackbarHidden" :color="color" :top="position === 'top'")
       v-layout(align-center pr-4)
        v-icon(:color="vencimentoColor" class="pr-3" medium) {{ icon }}
        v-layout(column)
         div().tertiary--text.font-weight-light {{ text }}
       v-btn(icon dark flat @click="snackbarHidden = true ")
        v-icon(medium).tertiary--text.font-weight-light close
      v-menu(offset-y)
        template(v-slot:activator='{ on }')
         div(v-if="profile === 'supervisor' || profile === 'manager'")
          v-btn(icon v-on='on')
            v-icon(:color="vencimentoColor") credit_card
        v-list
          v-subheader Boletos
          v-list-tile(
              v-for='(item, index) in financeItems',
              :key='index',
              @click='onOpenBoleto(item.id)'
            )
            v-list-tile-content
              v-list-tile-sub-title {{ item.data | date }}
              v-list-tile-title R$ {{ item.valor | money }}
            v-list-tile-action
              v-icon(:color="item.alert") request_quote
      v-menu(offset-y)
        template(v-slot:activator='{ on }')
          v-btn(icon, v-on='on')
            v-icon(color="black") person
        v-list
          v-list-tile(v-for='(item, index) in userMenuItems', :key='index', @click='onClick(item.method)')
            v-list-tile-content
              v-list-tile-sub-title(v-if="item.subtitle") {{ item.subtitle }}
              v-list-tile-title {{ item.title }}
    v-navigation-drawer#app-drawer.navigation-drawer(
      app
      fixed
      floating
      persistent
      v-model='drawer'
      mobile-break-point="991"
      width="260"
    )
      v-layout.fill-height(tag="v-list" column)
        v-list-tile(avatar)
          v-list-tile-title.text-xs-center
            img(src='@/assets/logo-main.png' height="125" contain)
        v-list-tile
          v-text-field(
            label="CPF / Matrícula"
            v-model="search"
            outline
            hide-details
            clearable
            append-icon="search"
            v-on:keyup.enter="searchCustomer"
            @click:append="searchCustomer")
        template(v-for='item in menuItemsComputed')
          v-list-tile.v-list-item(
            v-if='!item.children'
            :key='item.title'
            :to='item.link'
            active-class="amber"
            avatar
          )
            v-list-tile-content
              v-list-tile-title {{ item.title }}
            v-list-tile-action
              v-icon(color="error") {{ item.action }}
          v-list-group.v-list-item(
            v-else
            :key='item.title'
            v-model='item.active'
            :prepend-icon='item.action'
            avatar
          )
            template(v-slot:activator)
              v-list-tile
                v-list-tile-content
                  v-list-tile-title {{ item.title }}
            v-list-tile.v-list-item.mx-0(
              v-for='subItem in item.children'
              :key='subItem.title'
              :to='subItem.link'
              active-class="amber"
              avatar
            )
              v-list-tile-content
                v-list-tile-title {{ subItem.title }}
              v-list-tile-action
                v-icon {{ subItem.action }}
    v-content
      v-slide-x-transition(mode='out-in')
        router-view(:key="$route.fullPath+searchKey")
      vue-snotify
    v-footer.footer.px-3(absolute)
      v-spacer
      span GestorConsig © 2022
    div.text-xs-center(v-if="profile !== 'administrator'")
      v-dialog(scrollable v-model='dialog' width='800' v-if="!isAgreedTerms || (!isTrialPeriod && !isAgreedContract)" persistent)
        v-card
          v-card-title.headline.primary.white--text(primary-title)
            | Termos de Uso
          v-card-text
            | Olá {{ userName }},</br></br>Estamos felizes em lhe ver novamente. Para continuar utilizando o sistema <span class="font-weight-bold">GESTOR CONSIG</span>, será necessário que o gestor aceite os termos de uso.</br></br>
            div(v-if="profile == 'manager'")
              div(v-if="!isTrialPeriod")
                | Também é necessário a contratação do sistema. Segue nosso valores mensais dos planos disponíveis:</br>
                v-container.grid-list-xl.text-xs-center
                  v-layout.row.wrap
                    v-flex(md4 :class="planCode == 'basic' ? 'primary' : ''")
                      v-card
                        v-card-title.subheading.indigo.white--text Plano básico
                        v-divider
                        v-list.dense
                          v-list-tile
                            v-list-tile-content Usuários
                            v-list-tile-content.align-end.font-weight-bold 1
                          v-list-tile
                            v-list-tile-content Mensalidade
                            v-list-tile-content.align-end.font-weight-bold R$ 200
                    v-flex(md4 :class="planCode == 'advanced' ? 'primary' : ''")
                      v-card
                        v-card-title.subheading.blue.white--text Plano avançado
                        v-divider
                        v-list.dense
                          v-list-tile
                            v-list-tile-content Usuários
                            v-list-tile-content.align-end.font-weight-bold 2 a 9
                          v-list-tile
                            v-list-tile-content Mensalidade
                            v-list-tile-content.align-end.font-weight-bold R$ 500
                    v-flex(md4 :class="planCode == 'extended' ? 'primary' : ''")
                      v-card
                        v-card-title.subheading.cyan.white--text Plano estendido
                        v-divider
                        v-list.dense
                          v-list-tile
                            v-list-tile-content Usuários
                            v-list-tile-content.align-end.font-weight-bold 10 ou mais
                          v-list-tile
                            v-list-tile-content Mensalidade
                            v-list-tile-content.align-end.font-weight-bold R$ 1500
                span.subheading *** Atualmente você tem {{ usersCount }} usuário(s) ativo(s) no sistema. Seu plano será o Plano {{ planName }} no valor mensal de R$ {{ planValue }}, a primeira cobrança será feita em boleto com vencimento para o dia {{ planDueDate | date }}.</br></br>
                | Qualquer dúvida referente a assinatura do sistema, solicitamos que entre em contato com seu gerente comercial.
              v-container.grid-list-md.text-xs-center
                v-layout.row.wrap
                  v-flex(md12)
                    v-checkbox.justify-center(v-model="terms" label="Aceitar os termos de uso.")
                      span(slot="label") Aceitar os
                        v-tooltip
                          template(v-slot:activator="{ on }")
                            a.font-weight-bold(@click.stop href="termos_de_uso.pdf" target="_blank" v-on="on")  Termos de Uso
                          span Clique para visualizar os Termos de Uso.
          v-divider
          v-card-actions
            v-btn(v-if="profile !== 'manager'" @click="onSignOut()") Sair do sistema
            v-btn(v-if="profile === 'manager' && !isTrialPeriod" color='error' @click='disagree()') Não tenho interesse
            v-spacer
            v-btn(v-if="(profile === 'manager' && isTrialPeriod) || profile !== 'manager'" @click="agreeTerms()") Aceito os Termos de Uso
            v-btn(v-if="profile === 'manager' && !isTrialPeriod" color='primary' @click='agree()') Contratar plano {{ planName }}
      v-dialog(v-model='dialog' width='800' v-if="userData && !userData.terms && profile !== 'manager'" persistent)
        v-card
          v-card-title.headline.primary.white--text(primary-title)
            | Termos de Uso
          v-card-text
            | Olá {{ userName }},</br></br>Estamos felizes em lhe ver. Para continuar utilizando o sistema <span class="font-weight-bold">GESTOR CONSIG</span>, será necessário que realize o aceite dos termos de uso.</br></br>
          div(v-if="profile === 'attendant'")
            v-container.grid-list-md.text-xs-center
              v-layout.row.wrap
                v-flex(md12)
                  v-checkbox.justify-center(v-model="terms" label="Aceitar os termos de uso.")
                    span(slot="label") Aceitar os
                      v-tooltip
                        template(v-slot:activator="{ on }")
                          a.font-weight-bold(@click.stop href="termos_de_uso_atendente.pdf" target="_blank" v-on="on")  Termos de Uso
                        span Clique para visualizar os Termos de Uso.
          div(v-if="profile === 'supervisor'")
            v-container.grid-list-md.text-xs-center
              v-layout.row.wrap
                v-flex(md12)
                  v-checkbox.justify-center(v-model="terms" label="Aceitar os termos de uso.")
                    span(slot="label") Aceitar os
                      v-tooltip
                        template(v-slot:activator="{ on }")
                          a.font-weight-bold(@click.stop href="termos_de_uso_supervisor.pdf" target="_blank" v-on="on")  Termos de Uso
                        span Clique para visualizar os Termos de Uso.
          v-divider
          v-card-actions
            v-btn(v-if="profile !== 'manager'" @click="onSignOut()") Sair do sistema
            v-btn(v-if="profile === 'manager' && !isTrialPeriod" color='error' @click='disagree()') Não tenho interesse
            v-spacer
            v-btn(v-if="(profile === 'manager' && isTrialPeriod) || profile !== 'manager'" @click="agreeTerms()") Aceito os Termos de Uso
            v-btn(v-if="profile === 'manager' && !isTrialPeriod" color='primary' @click='agree()') Contratar plano {{ planName }}
</template>

<script>
import { mapGetters } from 'vuex'
import { db, auth, app, functions } from '@/store/firebase'
import firestoreUtils from '@/utils/firestore'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'decorator',

  computed: {
    ...mapGetters(['profile', 'user', 'scheduleCount', 'companyData']),
    userName() {
      return this.userData && this.userData.name ? this.userData.name : ''
    },
    menuItemsComputed() {
      let profile = this.profile
      let list = []
      this.menuItems.forEach(item => {
        if (item.notAllow && !item.notAllow.includes(profile)) {
          list.push(item)
        }
      })

      let result = list.map(item => {
        if (item.children && profile !== 'attendant') {
          const listChildren = item.children.filter(subItem => {
            return subItem.notAllow.indexOf(profile) < 0
          })
          item.children = listChildren
          return item
        }

        return item
      })

      return result
    },
    planName() {
      return this.usersCount === 1 ? 'Básico' : this.usersCount < 10 ? 'Avançado' : 'Estendido'
    },
    planCode() {
      return this.usersCount === 1 ? 'basic' : this.usersCount < 10 ? 'advanced' : 'extended'
    },
    planValue() {
      return this.usersCount === 1 ? 200 : this.usersCount < 10 ? 500 : 1500
    },
    planDueDate() {
      const currentTime = new Date()
      currentTime.setDate(currentTime.getDate() + 4)
      return currentTime
    },
    isAgreedTerms() {
      return this.companyData && this.companyData.terms && this.companyData.terms.agreed
    },
    isAgreedContract() {
      return this.companyData && this.companyData.contract && this.companyData.contract.agreed
    },
    isTrialPeriod() {
      const currentTime = new Date()
      currentTime.setDate(currentTime.getDate() - 1)
      const trial = this.companyData && this.companyData.trialDate && this.companyData.trialDate.toDate() >= currentTime
      return trial
    }
  },

  data() {
    return {
      phoneActivated: false,
      loaded: false,
      currentCustomer: '',
      dialog: false,
      userDialog: true,
      checked: false,
      msg: 'decorator',
      telefone: 'call_end',
      paused: false,
      drawer: true,
      drawerRight: true,
      right: null,
      left: null,
      btn: true,
      schedule: {},
      terms: false,
      search: '',
      searchKey: '',
      usersCount: null,
      userData: null,
      financeItems: [],
      covenantUpdatedDate: [],
      vencimentoColor: 'black',
      vencido: [],
      alertDate: '',
      snackbar: false,
      color: 'white',
      icon: 'credit_card',
      position: 'top',
      snackbarHidden: false,
      text: '',
      timeout: 15000,
      userMenuItems: [
        { title: 'Sair', method: 'onSignOut' }
      ],
      menuItems: [
        {
          title: 'Visão Geral',
          link: '/',
          notAllow: ['administrator']
        },
        {
          title: 'Relatórios',
          link: '/report',
          notAllow: ['administrator', 'attendant']
        },
        {
          title: 'Oportunidades',
          link: '/board',
          notAllow: ['administrator']
        },
        {
          title: 'Clientes',
          link: '/customers',
          notAllow: ['administrator']
        },
        {
          title: 'Agendamentos',
          link: '/schedules',
          action: null,
          notAllow: ['administrator']
        },
        {
          title: 'Campanhas',
          link: '/campaigns',
          notAllow: ['administrator', 'attendant', 'supervisor']
        },
        {
          title: 'Distribuição',
          link: '/distributions',
          notAllow: ['administrator', 'attendant']
        },
        {
          title: 'Configurações',
          notAllow: ['attendant'],
          children: [
            {
              title: 'Bancos',
              link: '/banks',
              notAllow: ['administrator', 'manager', 'supervisor', 'attendant']
            },
            {
              title: 'Empresas',
              link: '/companies',
              notAllow: ['manager', 'supervisor', 'attendant']
            },
            {
              title: 'Faturamento',
              link: '/billing',
              notAllow: ['manager', 'supervisor', 'attendant']
            },
            {
              title: 'Lojas',
              link: '/stores',
              notAllow: ['supervisor', 'attendant']
            },
            {
              title: 'Usuários',
              link: '/users',
              notAllow: ['attendant']
            },
            {
              title: 'Metas',
              link: '/goals',
              notAllow: ['administrator', 'manager', 'supervisor', 'attendant']
            },
            {
              title: 'Status',
              link: '/statuses',
              notAllow: ['administrator', 'attendant']
            },
            {
              title: 'Upload',
              link: '/uploads',
              notAllow: ['manager', 'supervisor', 'attendant']
            },
            {
              title: 'Blacklist',
              link: '/blacklists',
              notAllow: ['manager', 'supervisor', 'attendant']
            }
          ]
        }
      ]
    }
  },

  watch: {
    scheduleCount(val) {
      this.updateScheduleInfo()
    },
    companyData(val) {
      this.getFinances()
      this.checkRamalStatus()
      if (this.userData.currentCustomer) {
        this.currentCustomer = this.userData.currentCustomer
      } else {
        this.currentCustomer = ''
      }
      this.getCovenantLastUpdatedDate()
      this.redirectToClientInfo()
    }
  },

  mounted() {
    this.initialize()
    this.setMenuUser()
    this.updateScheduleInfo()
    // this.menuItemsResult()
  },

  methods: {
    initialize() {
      this.$store.dispatch('loadCompanyData')
        .then(() => {
          this.dialog = true
        })
      if (this.user.profile === 'manager') {
        this.$store.dispatch('findUsersCount')
          .then(count => {
            this.usersCount = count
          })
      }
      this.getFinances()
    },
    async OnPause() {
      let response
      let dados
      if (this.paused === false && this.phoneActivated === true) {
        dados = { email: this.userData.ramalLogin, tipo: 'INTERVALO', ativa: 'Sim' }
        response = await functions.httpsCallable('putAttendantOnPause')({ dados, url: this.companyData.url })
        if (response.data.Response === 'Success') {
          this.paused = true
          this.$snotify.success('Pausa efetuada com sucesso!', {
            timeout: 1000,
            pauseOnHover: false
          })
        } else {
          this.$snotify.error('Ops! Ocorreu um erro ao tentar Pausar, tente novamente')
        }
      } else if (this.paused === true) {
        dados = { email: this.userData.ramalLogin, tipo: 'INTERVALO', ativa: 'Não' }
        response = await functions.httpsCallable('putAttendantOnPause')({ dados, url: this.companyData.url })
        if (response.data.Response === 'Success') {
          this.paused = false
          this.$snotify.success('Removido da pausa com sucesso!', {
            timeout: 1000,
            pauseOnHover: false
          })
        } else {
          this.$snotify.error('Ops! Ocorreu um erro ao tentar sair da pausa, tente novamente')
        }
      }
    },

    async phoneClick() {
      let response
      if (this.phoneActivated === false) {
        response = await functions.httpsCallable('phoneActivateOnCall')({ login: this.userData.ramalLogin, password: this.userData.ramalPassword, url: this.companyData.url })
        if (response.data.Response === 'Success') {
          this.phoneActivated = true
          this.telefone = 'phone'
          this.$snotify.success('Logado com sucesso!', {
            timeout: 1000,
            pauseOnHover: false
          })
        } else {
          this.$snotify.error('Ops! Ocorreu um erro ao logar, tente novamente')
        }
      } else {
        response = await functions.httpsCallable('phoneDesactivatedOnCall')({ login: this.userData.ramalLogin, password: this.userData.ramalPassword, url: this.companyData.url })
        if (response.data.Response === 'Success') {
          this.phoneActivated = false
          this.telefone = 'call_end'
          this.$snotify.success('Deslogado com sucesso!', {
            timeout: 1000,
            pauseOnHover: false
          })
        } else {
          this.$snotify.error('Ops! Ocorreu um erro deslogar, tente novamente')
        }
      }
    },

    async checkRamalStatus() {
      let response
      if (this.companyData.url !== '' && this.companyData.url !== undefined) {
        response = await functions.httpsCallable('dialRamalStatus')({ url: this.companyData.url })
        if (response.data.logado === 1) {
          this.phoneActivated = true
          this.telefone = 'phone'
          if (response.data.pausa === 1) {
            this.paused = true
            this.$snotify.info('Agente Pausado no Discador!', {
              timeout: 1000,
              pauseOnHover: false
            })
          } else {
            this.$snotify.info('Agente Logado no Discador!', {
              timeout: 1000,
              pauseOnHover: false
            })
          }
        }
      }
    },

    agreeTerms() {
      if (!this.terms) return alert('Você precisa aceitar os termos de uso do sistema. Favor marcar a opção "Aceitar os termos de uso."')
      if (this.profile === 'manager') {
        this.$store
          .dispatch('agreeTerms', { userName: this.userName })
          .then(() => {
            this.$store.dispatch('loadCompanyData')
          })
      } else {
        this.$store.dispatch('agreeUserTerms', { userName: this.userName }).then(() => {
          this.dialog = false
        })
      }
    },

    agree() {
      if (!this.terms) return alert('Você precisa aceitar os termos de uso do sistema. Favor marcar a opção "Aceitar os termos de uso."')
      this.$store
        .dispatch('agreeContract', { plan: this.planCode, planName: this.planName, dueDate: this.planDueDate, feeValue: this.planValue, userName: this.userName })
        .then(() => {
          this.$store.dispatch('loadCompanyData')
        })
    },

    disagree() {
      this.$store.dispatch('disagreeContract')
        .then(() => {
          alert('O acesso ao sistema será bloquado. Esperamos revê-los em breve.')
          this.onSignOut()
          window.location.reload()
        })
    },

    translateProfile(profile) {
      switch (profile) {
        case 'administrator':
          return 'Administrador'
        case 'manager':
          return 'Gerente'
        case 'supervisor':
          return 'Supervisor'
        case 'attendant':
          return 'Atendente'
      }
    },

    searchCustomer() {
      this.searchKey = this.search
      this.$router.push({ name: 'Informações', params: { cpf: this.search.replaceAll(/\D/g, '') } })
    },

    async setMenuUser() {
      const doc = await db.collection('users').doc(this.user.uid).get()
      let user = firestoreUtils.docToObject(doc)
      this.userData = user
      this.loaded = true
      this.userMenuItems.unshift({ title: user.name, subtitle: this.translateProfile(user.profile), method: '' })
    },

    async getFinances() {
      if (!this.companyData ||
          !this.companyData.integrations ||
          !this.companyData.integrations.contaAzul ||
          !this.companyData.integrations.contaAzul.customerId
      ) return
      const financesDocs = await db.collection('finances').where('cliente.uuid', '==', this.companyData.integrations.contaAzul.customerId).where('baixado', '==', false).get()
      const finances = []
      this.alertDate = moment().add(5, 'days').startOf('days').toDate().getTime()
      financesDocs.forEach(item => {
        const finance = firestoreUtils.docToObject(item)
        finance.data = new Date(finance.data)
        finances.push(finance)
      })
      this.financeItems = _.sortBy(finances, ['data'])
      let snackbarTrue = false
      finances.forEach(boleto => {
        if (boleto) {
          if (boleto.data < this.alertDate) {
            let day = new Date()
            let date = new Date(day.getTime() - 86400000)
            if (boleto.data < date) {
              db.collection('finances').doc(boleto.uuid).update({ alert: 'error' })
              this.vencimentoColor = 'error'
              this.text = 'Você tem um ou mais boletos que estão vencidos.'
              snackbarTrue = true
            } else {
              db.collection('finances').doc(boleto.uuid).update({ alert: 'amber' })
              if (this.vencimentoColor !== 'error') {
                this.vencimentoColor = 'amber'
                this.text = 'Boleto perto da data de vencimento.'
                snackbarTrue = true
              }
            }
          } else {
            db.collection('finances').doc(boleto.uuid).update({ alert: '' })
          }
        }
      })
      this.snackbar = snackbarTrue
    },

    async getCovenantLastUpdatedDate() {
      const doc = await db.collection('jobStatus').doc('JOB_INFO').get()
      let convenants = await firestoreUtils.docToObject(doc)
      let convenantsKeys = Object.keys(convenants)
      for (let index = 0; index < convenantsKeys.length; index++) {
        let name = convenantsKeys[index]
        if (name !== 'updatedAt' && name !== 'iuid') {
          this.covenantUpdatedDate.push({ name: name, date: convenants[name] })
        }
      }
      this.covenantUpdatedDate.sort((a, b) => b.date - a.date)
    },
    updateScheduleInfo() {
      if (this.user.profile === 'administrator') return
      const [menu] = this.menuItems.filter(item => item.link && item.link === '/schedules')

      if (this.scheduleCount) {
        menu.action = 'info'
      } else {
        menu.action = null
      }
      this.menuItems.push()
    },

    onClickRoute(route) {
      this.$router.push(route)
    },
    onClick(method) {
      if (!method) return
      this[method]()
    },

    async onOpenBoleto(id) {
      this.$snotify.warning('Seu boleto será exibido em breve, por favor aguarde.')
      if (typeof id === 'string') {
        window.open(id)
      } else {
        app.functions('southamerica-east1')
          .httpsCallable('boletoLinkOnCall')({ id: id })
          .then(result => {
            window.open(result.data.externalUrl)
          })
          .catch(err => {
            console.error(JSON.stringify(err))
            this.$snotify.error('Erro ao buscar boleto.')
          })
      }
    },
    onSignOut() {
      auth
        .signOut()
        .then(res => {
          this.$router.push('/login/sign-in')
        })
        .catch(err => {
          console.log(err)
        })
    },
    goToConfig() {
      this.$router.push('/upload')
    },
    async redirectToClientInfo() {
      db.collection('users').doc(this.user.uid).onSnapshot(snapshot => {
        const userData = snapshot.data()
        if (userData.currentCustomer && userData.currentCustomer !== this.currentCustomer) {
          this.currentCustomer = userData.currentCustomer
          if (userData.currentCustomer !== '') {
            if (userData.firstCustomerAttendant) {
              this.$router.push('/customer/' + this.currentCustomer)
            } else if (userData.firstCustomerAttendant !== undefined) {
              this.$snotify.warning('este cliente já está vinculado a outro atendente')
              this.$router.push('/info/' + this.currentCustomer.slice(-11))
            }
          }
        }
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
.menu-container-logo {
  margin: 20px 0;
  width: 100%;
  text-align: center;
}

.menu-img-logo {
  width: 200px;
  max-height: 200px;
}

.v-content {
  padding-bottom: 40px !important;
}

.footer {
  min-height: 32px;
}

div >>> aside {
  z-index: 150;
}

.navigation-drawer >>> .v-list__tile, .v-list__group .v-list__group__header {
  border-radius: 4px;
}

.navigation-drawer >>> .v-list .v-list-item .v-list__tile.v-list__tile--active {
  color: white !important;
}

.navigation-drawer >>> .v-list .v-list-item:nth-child(3) {
  margin: 10px 15px 0;
}

.navigation-drawer >>> .v-list__group--active .v-list__group__header {
  background-color: hsla(0, 0%, 78.4%, 0.2);
}

.navigation-drawer >>> .v-list__group--active:before, .v-list__group--active:after {
  background: none !important;
}

.navigation-drawer >>> .v-list__group__header .v-list__tile__title, .v-list__group__header .v-list__group__header__append-icon {
  font-weight: 300 !important;
}

.v-tooltip__content {
  background: #ffffff;
}
</style>

<style lang="scss">
@import "~vue-snotify/styles/material";
</style>
